<template>
  <el-row style="padding: 1.25rem;">
    <div v-if="liad_show">
      <load></load>
    </div>
    <el-row style="margin-top: 0.625rem;">
      <router-link :to="{path:'quest_add'}">
      <el-button type="primary" style="">
        <i class="el-icon-plus"></i>
        创建问卷</el-button>
      </router-link>
      <el-button type="primary" style="margin-left: 1.25rem;" @click="type_show='tow'">
        <i class="el-icon-thumb"></i>
        问卷列表</el-button>
        <el-button type="primary" style="margin-left: 1.25rem;" @click="button_type()">
          <i class="el-icon-thumb"></i>
          标准问卷</el-button>
      <el-input @change="input_change()" v-model="input" style="width: 12.5rem;float: right;"  placeholder="请输入内容"></el-input>
    </el-row>
    <el-row v-if="type_show!='one'" >
      <el-row :style="{height:tow_height}" class="over">
        <el-card class="box-card" style="margin-top: 1.25rem; " v-for="(item,index) in list" :key="index" >
          <el-row slot="header" class="clearfix">
            <span style="font-size: 16px;line-height: 22px;">{{item.name}}</span>
          </el-row>
          <el-row  class="text item">
            <span>
              <span style="margin-right: 1.25rem;">创建人：{{item.companyee}}</span>
              <span  style="margin-right: 1.25rem;">
                <span  v-if="item.status==1">状 态：<span style="color: #0095ff;">已发布</span></span>
                <span  v-else-if="item.status==2">状 态：<span style="color: red;">已禁用</span></span>
                <span  v-else-if="item.status==-1">状 态：<span style="color: red;">已删除</span></span>
                <span v-else>状 态：未发布</span>
              </span>
              <span  style="margin-right: 1.25rem;">创建时间：{{item.c_time}}</span>
            </span>
            <span style="float: right;" v-if="item.status!=2 && item.status!=-1  ">
              <span class="con_right" @click="goto('release',item.num)" v-if="item.status==1">发布问卷</span>
              <span class="con_right" @click="goto('quest_add',item.num)" v-if="item.status!=1">编辑</span>
              <span class="con_right" @click="goto('make_up',item.num)" v-if="item.status!=1">组成问卷</span>
              <span class="con_right" @click="goto('preview',item.num)">预览</span>
              <span class="con_right" @click="goto('Disable',item.num)">
                <el-popconfirm title='确认禁用？？？'
                     confirm-button-text='确定'
                     cancel-button-text='取消'
                     icon='el-icon-delete'
                     icon-color='red'
                     @confirm='handleConfirm_dis(item.num)'
                     @cancel='handleCancel'>
                     <span slot='reference'>禁用</span>
                 </el-popconfirm>
              </span>
              <span class="con_right" @click="goto('del',item.num)">
                <el-popconfirm title='确认删除？？？'
                     confirm-button-text='确定'
                     cancel-button-text='取消'
                     icon='el-icon-delete'
                     icon-color='red'
                     @confirm='handleConfirm_del(item.num)'
                     @cancel='handleCancel'>
                     <span slot='reference'>删除</span>
                 </el-popconfirm>
                </span>
            </span>
          </el-row>
        </el-card>
        <el-row v-if="pagination.total==0" style="min-height: 18.75rem; display: flex;justify-content: center;align-items: center;">
          <span>暂无您搜索的内容，请重新搜索哦</span>
        </el-row>
      </el-row>
      <el-row style="text-align: center;margin-top: 1.875rem;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[4, 8,16,42]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
        </el-pagination>
      </el-row>
    </el-row>
    <el-row v-else style="border-top: 1px solid #e8e8e8; margin-top: 1.5625rem;text-align: center;">
      <el-row style="margin-top: 1.25rem;">
        <el-row style="color: #262626;font-size: 18px;">
          <h2>创建只需要三步</h2>
        </el-row>
        <el-row style="color: #888; font-size: 14px; margin-top: 0.8 rem;" v-if="pagination.total==0">您目前还没有问卷，马上创建一份问卷吧！</el-row>
        <el-row style="color: #888; font-size: 14px; margin-top: 0.8 rem;" v-else>点击试卷列表即可查看您的组卷记录哦</el-row>
        <el-row style="margin: 0 1.25rem; margin-top: 2.25rem;">
          <el-col :span="6" v-for="(o, index) in no_list" :key="index" :offset="index > 0 ? 3 : 0">
          <div  @click="img_goto(index)">
            <el-card :body-style="{ padding: '0px' }">
              <img  v-if="index==0" src="../../../../assets/questionnaire1.png"  class="image">
              <img  v-if="index==1" src="../../../../assets/questionnaire2.png"  class="image">
              <img  v-if="index==2" src="../../../../assets/questionnaire3.png"  class="image">
              <div style="padding: 14px;">
                <h2>{{o.name}}</h2>
              </div>
            </el-card>
          </div>
          </el-col>
        </el-row>
      </el-row>

    </el-row>

    <el-dialog
      title="标准问卷"
      :visible.sync="standard.show"
      width="50%">
       <el-table
          :height="dialog_height"
          :data="standard.list"
          stripe
          style="width: 100%;overflow: auto;">
          <el-table-column
            prop="name"
            label="名称">
          </el-table-column>
          <el-table-column
            label="操作"
            width="100">
            <template slot-scope="scope">
              <el-button @click="standard_cilck(scope.row,'see')" type="text" size="small">查看</el-button>
              <el-button type="text" size="small" @click="goto('quest_add',scope.row.num,)">编辑</el-button>
            </template>
          </el-table-column>
       </el-table>
          <span slot="footer" class="dialog-footer">
            <el-button  @click="standard.show = false">关 闭</el-button>
          </span>
    </el-dialog>

  </el-row>
</template>

<script>
  import load from "../../../../components/load.vue"
    export default {
      data() {
        return {
          dialog_height:window.innerHeight * 0.6 + 'px',
          standard:{//标准
            show:false,
            list:[]
          },
          tow_height:'',
          popover_show_del:false,//确认删除或是禁用按钮
          popover_show_dis:false,
          liad_show:false,
          pagination:{
            limit:4,
            currentPage:1,
            total:0,
          },
          type_show:'one',
          list:{},
          input:'',
          no_list:[{
            name:'创建',
          },
          {
            name:'发布',
          },
          {
            name:'记录',
          },]
        }
      },
      components: {
         load:load
      },
      mounted () {
        this.tow_height= window.innerHeight * 0.8 + 'px'
        this.get_info()
      },

      methods: {
        standard_cilck(item,type){
          let _this=this
          if(type=='see'){
            _this.$router.push({path:'/quest_preview',query:{num:item.num}})
          }else{

          }

        },
        button_type(){
          let _this=this
          _this.standard.show=true
          _this.liad_show=true
          _this.axios.get("/v2/c_investigate/investigate").then(function (res) {
            if(res.data.code=='1'){
              _this.standard.list=res.data.data
              _this.liad_show=false
            }else{
              _this.$message.error(res.data.msg)
              _this.liad_show=false
            }
          })
        },
        img_goto(index){
          if(index==0){
            this.$router.push({path:'/quest_add'})
          }else if(index==1){
            this.type_show='tow'
          }else{
            this.$router.push({path:'../quest_data_list'})
          }
        },
        input_change(){
          this.type_show='tow'
          this.pagination.limit=4
          this.pagination.currentPage=1
          this.get_info()

        },
        handleSizeChange(val) {
          this.pagination.limit=val
          this.get_info()
        },
        handleCurrentChange(val) {
          this.pagination.currentPage=val
          this.get_info()
        },
        get_info(){
          let _this=this
          _this.liad_show=true
          _this.axios.get("/v2/c_investigate/investigate_list",{params: {
            limit:_this.pagination.limit,
            page:_this.pagination.currentPage,
            keyword:_this.input
          }}).then(function (res) {
            if(res.data.code=='1'){
              _this.pagination.total=res.data.data.list.total
              _this.pagination.currentPage=res.data.data.list.current_page
              _this.list=res.data.data.list.data
              _this.liad_show=false
            }else{
              _this.$message.error(res.data.msg)
              _this.liad_show=false
            }
          })
        },
        goto(type,num){
          if(type=='release'){
            this.$router.push({path:'/quest_release',query:{num:num}})
          }else if(type=='preview'){
            this.$router.push({path:'/quest_preview',query:{num:num}})
          }else if(type=='quest_add'){
            this.$router.push({path:'/quest_add',query:{num:num}})
          }else if(type=='make_up'){
            this.poat_investigate_up(1,num)
          }
        },
        handleConfirm_del(num){
            this.poat_investigate_up(-1,num)
        },
        handleConfirm_dis(num){
            this.poat_investigate_up(2,num)
        },
        handleCancel(){
        },
        poat_investigate_up(type,num){
          let _this=this
          _this.liad_show=true
          let data={
            type:'status',
            num:num,
            status:type
          }
          _this.axios.post("/v2/c_investigate/investigate_up",{data:data}).then(function (res) {
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              _this.liad_show=false
              _this.get_info()
            }else{
              _this.$message.error(res.data.msg)
              _this.liad_show=false
            }
          })
        },
      }

    }
</script>

<style  scoped>
   div::-webkit-scrollbar {
      width: 4px;
    }
    div::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      opacity: 0.2;
      background: fade(@primary-color, 60%);
    }
    div::-webkit-scrollbar-track {
      -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
      border-radius: 0;
      background: fade(@primary-color, 30%);
    }
  .over{
    overflow: auto;
    overflow-x:hidden;
  }
   .time {
      font-size: 13px;
      color: #999;
    }
    .bottom {
      margin-top: 13px;
      line-height: 12px;
    }

    .button {
      padding: 0;
      float: right;
    }

    .image {
      width: 100%;
      display: block;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }
  >>>.el-input__inner{
    border-radius: 62.4375rem;
  }
  span{
     cursor: pointer;
  }
  .con_right{
     margin-right: 0.625rem;
     color: #7a7a7a;
  }
   .text {
      font-size: 14px;
    }

    .item {
      margin-bottom: 18px;
    }

    .clearfix:before,
    .clearfix:after {
      display: table;
      content: "";
    }
    .clearfix:after {
      clear: both
    }

    .box-card {
      width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/view/company/questionnaire/quest_list/list.vue